import { Link } from 'react-router-dom';
import { LANGUAGES } from '../seo/languages';

function Languages() {
  return (
    <div className="page-container languages-page">
      <Link to="/" className="back-button">← Back to LangShazam</Link>
      <h1>Supported Languages</h1>
      <p className="languages-intro">
        LangShazam detects and transcribes <strong>{LANGUAGES.length} spoken languages</strong> from
        audio in real time. We are building state-of-the-art language detection: a real-time
        multilingual speech model listens to the audio itself, names the language within a phrase,
        and keeps a live transcript as you speak. Tap a language to see how it is detected.
      </p>
      <div className="languages-grid">
        {LANGUAGES.map(lang => (
          <Link key={lang.slug} to={`/languages/${lang.slug}`} className="language-card language-card-link">
            <div className="language-name">{lang.name}</div>
            <div className="language-native">{lang.nativeName}</div>
            <div className="language-meta">{lang.region}</div>
            <div className="language-speakers">{lang.speakers} native speakers</div>
          </Link>
        ))}
      </div>
      <p className="languages-cta">
        Speaking one of these? <Link to="/">Detect it now →</Link>
      </p>
    </div>
  );
}

export { LANGUAGES };
export default Languages;
